<script setup lang="ts">
import LinkComponent from "~/templates/components/cms/LinkComponent.vue";
import {
  containsLink,
  filterNodesByType,
  filterNodesByTypes,
  getImageAlt,
  imagePath,
  mapNodes,
} from "~/utils/helper/magnolia";

export interface FooterColumnContentProps {
  column: {
    displayAs: "button" | "link";
    name?: string;
    title?: string;
    item: {
      image?: {
        metadata: {
          description?: string;
          fileName: string;
          fileSize?: number;
          height?: number;
          mimeType?: string;
          title?: string;
          width?: number;
        };
        name?: string;
      };
      link?: {
        label: string;
        link: string;
        type?: string;
        url?: string;
      };
    };
  };
}

defineProps<FooterColumnContentProps>();
</script>

<template>
  <div v-if="column.displayAs === 'button'" class="flex h-full flex-col justify-between">
    <div class="flex flex-wrap gap-2">
      <template v-for="item in filterNodesByType(mapNodes(column), 'nav:link')" :key="item.name">
        <LinkComponent
          v-if="item.image"
          :link="item.link"
          :aria-label="containsLink(item.link) ? (item.link?.label ?? 'icon-link') : null"
          class="btn min-h-0 border-0 bg-white p-0"
          ><img
            class="aspect-2/1 h-8 object-contain p-2 xl:h-10"
            :src="imagePath(item.image)"
            :alt="getImageAlt(item.image)"
        /></LinkComponent>
        <LinkComponent v-else :link="item.link" class="btn btn-blue btn-size-small text-sm">{{
          item?.link?.label
        }}</LinkComponent>
      </template>
    </div>
  </div>
  <div v-else class="flex flex-col gap-2">
    <template
      v-for="item in filterNodesByTypes(mapNodes(column), ['nav:link', 'footer:col'])"
      :key="item.name"
    >
      <LinkComponent
        v-if="item['@nodeType'] === 'nav:link'"
        class="cursor-pointer"
        optional-link-classes="hover:text-dark-blue"
        :link="item.link"
        >{{ item?.link?.label }}</LinkComponent
      >
      <div v-else-if="item['@nodeType'] === 'footer:col'" class="flex flex-col gap-2">
        <LinkComponent
          :link="item.link"
          class="font-medium"
          optional-link-classes="hover:text-dark-blue"
          >{{ item.title }}</LinkComponent
        >
        <LinkComponent
          v-for="link in filterNodesByType(mapNodes(item), 'nav:link')"
          :key="link['@id']"
          class="cursor-pointer"
          optional-link-classes="hover:text-dark-blue"
          :link="link.link"
          >{{ link?.link?.label }}</LinkComponent
        >
      </div>
    </template>
  </div>
</template>
